const $ = jQuery.noConflict();

class Tabs {
	constructor() {
		this.tabsButton = $('.block-tabs__item');
	}
	init() {
		this.bindEvents();
	}
	bindEvents() {
		this.tabsButton.on('click', this.changeTab);
	}
	changeTab() {
		const $tabsBlock = $(this).closest('.block-tabs');
		const showTab = $(this).attr('aria-controls');
		if (
			$tabsBlock.find('#' + showTab) &&
			!$tabsBlock.find('#' + showTab).hasClass('block-tab--active')
		) {
			$tabsBlock.find('.block-tabs__item').attr('aria-selected', 'false');
			$(this).attr('aria-selected', 'true');
			$tabsBlock.find('.block-tab').removeClass('block-tab--active');
			$tabsBlock.find('#' + showTab).addClass('block-tab--active');
		}
	}
}

const newTabs = new Tabs();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		newTabs.init();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
